module.exports = __webpack_public_path__ + "img/sleeve opening.925bdb47.png";